export default function getThemeStyleClass(theme = null, shade = 0) {
  if (theme === null) return 'theme-undefined'
  else return 'theme-' + theme.toLowerCase() + '-' + shade
}
